import React from "react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { SIMULATOR_RUN_ACCENT } from "./simulatorRunWizardConstants";

export type SimulatorBackNavProps = {
  label: string;
  subtleText: string;
  onClick: () => void;
};

/** Ghost back control used above page titles (wizard, results). */
export function SimulatorBackNav(props: SimulatorBackNavProps): React.ReactElement {
  const { label, subtleText, onClick } = props;
  return (
    <Button
      variant="ghost"
      h="auto"
      minH="32px"
      px={0}
      mb={6}
      color={subtleText}
      fontFamily="'IBM Plex Sans', sans-serif"
      fontSize="sm"
      fontWeight="medium"
      leftIcon={<ArrowBackIcon />}
      onClick={onClick}
      _hover={{ color: SIMULATOR_RUN_ACCENT, bg: "transparent" }}
    >
      {label}
    </Button>
  );
}
